import React from 'react'
import { css } from '@linaria/core'
import { FlowGrid, Radio, useContainerWidth } from '@fs/zion-ui'

const listItemCss = css`
  margin: 0;
  padding: 0;
  list-style: none;
`

export default function LangList({
  orderedLangs = [],
  selectedLocale = 'en',
  setSelectedLocale,
  fieldName = 'locale',
  orientation = 'vertical',
}) {
  const atWidth = useContainerWidth()
  const columns = atWidth({ default: 1, xs: 2, md: 3 })
  return (
    <div style={{ maxWidth: 600 }}>
      <FlowGrid as="ul" columnCount={columns} orientation={orientation} guttersY="none">
        {orderedLangs.map((lang) => (
          <li key={lang.code} className={listItemCss}>
            <Radio
              checked={selectedLocale === lang.code}
              name={fieldName}
              label={lang.text}
              inputProps={{ lang: lang.code }}
              value={lang.code}
              onChange={(e) => setSelectedLocale(e.target.value)}
            />
          </li>
        ))}
      </FlowGrid>
    </div>
  )
}
